import { motion } from 'framer-motion';
import styled from 'styled-components';

export const Wrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  font-size: 14px;
  padding: 0 20px;
  text-align: center;
`;

export const Text = styled.p`
  margin-bottom: 5px;
`;

export const IconsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  /* padding: 0 20px; */
  div {
    margin: 20px 20px 0 20px;
  }
`;
